import Maintenance from "@/views/public/Maintenance.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/maintenance",
        name: RouteEnum.MAINTENANCE,
        component: Maintenance
    },
]
